import { ref } from "vue";

const list = ref([]);

export const useToast = () => {

  const TIME_ERROR = 2000;
  const TIME_SUCCESS = 1000;
  const TIME_RANDOM = 500;
  
  const add = (message: string, type: string) => {
    const rand_id = Math.random().toString(36).substr(2, 5);
    list.value.push({
      message: message,
      type: type,
      id: rand_id
    });

    // Auto‑dismiss only “error” and “success” toasts
    if (type !== 'progress') {
      setTimeout(() => {
        remove(rand_id);
      }, type === 'error' ? TIME_ERROR + randMs() : TIME_SUCCESS + randMs());
    }

    return rand_id;
  }

  const randMs = () => {
    // maximum 1 second
    // minimum 0 milliseconds
    // 0 – 1000 milliseconds
    return Math.floor(Math.random() * TIME_RANDOM);
  }

  const error = (message: string) => {
    add(message, 'error');
  }

  const success = (message: string) => {
    add(message, 'success');
  }

  /**
   * Show a toast with an indeterminate/0 % progress bar.
   * Returns the toast id so the caller can update or dismiss it.
   */
  const progress = (message: string) => {
    const id = add(message, 'progress');
    const item = list.value.find(i => i.id === id);
    if (item) {
      item.progress = 0;

      // Auto‑increment progress while the exact percentage is unknown.
      // The algorithm is inspired by NProgress: it moves quickly at first
      // and slows down as it approaches 90 %.
      const trickle = () => {
        if (item.progress >= 90) return;                        // stop near the end
        const delta = (1 + Math.random() * 4) * (1 - item.progress / 100);
        item.progress = Math.min(item.progress + delta, 90);
      };

      // Store the timer id on the object so we can clear it later.
      (item as any).timer = setInterval(trickle, 250);
    }
    return id;
  }

  /**
   * Update the progress value (0 – 100). When it reaches 100 %
   * the toast is removed automatically.
   */
  const setProgress = (id: string, percent: number) => {
    const item = list.value.find(i => i.id === id);
    if (item) {
      // If an auto‑increment timer is running, stop it.
      if ((item as any).timer) {
        clearInterval((item as any).timer);
        delete (item as any).timer;
      }

      item.progress = percent;
      if (percent >= 100) {
        remove(id);
      }
    }
  }

  const successProgress = (id: string, message: string) => {
    const item = list.value.find(i => i.id === id);
    if (item) {
      item.type = 'success';
      // If an auto‑increment timer is running, stop it.
      if ((item as any).timer) {
        clearInterval((item as any).timer);
        delete (item as any).timer;
      }

      item.progress = 100;
      item.message = message;
      setTimeout(() => {
        remove(id);
      }, TIME_SUCCESS + randMs());
    }
  }

  const errorProgress = (id: string, message: string) => {
    const item = list.value.find(i => i.id === id);
    if (item) {
      item.type = 'error';
      // If an auto‑increment timer is running, stop it.
      if ((item as any).timer) {
        clearInterval((item as any).timer);
        delete (item as any).timer;
      }

      item.progress = 100;
      item.message = message;
      setTimeout(() => {
        remove(id);
      }, TIME_ERROR + randMs());
    }
  }
  

  const remove = (id: string) => {
    const item = list.value.find(i => i.id === id);
    if (item && (item as any).timer) {
      clearInterval((item as any).timer);
    }
    list.value = list.value.filter((item) => item.id !== id);
  }
   
  return { list, add, remove, error, success, progress, setProgress, successProgress, errorProgress };
}
